export default function useGetUserId(){
    const userInfoString = localStorage.getItem("userInfo");
    const userInfo = JSON.parse(userInfoString);
    const userId = userInfo.userId;

    return userId
}